import { action } from 'typesafe-actions';
import { CoreActionTypes, VisaStatus } from './types';
import { IAgent, IRegionConfig } from '../../../types';

export const updateLegalAdviseDisclaimer = (value: boolean) =>
  action(CoreActionTypes.UPDATE_LEGAL_ADVISE_DISCLAIMER, value);
export const updateInfoProcessing = (value: boolean, config: IRegionConfig) =>
  action(CoreActionTypes.UPDATE_INFO_PROCESSING, { value, config });
export const updateAssignedAgents = (assignedAgents: IAgent[], lockAgent: boolean) =>
  action(CoreActionTypes.UPDATE_ASSIGNED_AGENTS, { assignedAgents, lockAgent });
export const updateAssignedAgentsSuccess = (data: any) => action(CoreActionTypes.UPDATE_ASSIGNED_AGENTS_SUCCESS, data);
export const updateAssignedAgentsFailure = (message: string) =>
  action(CoreActionTypes.UPDATE_ASSIGNED_AGENTS_FAILURE, message);
export const updateVisaStatus = (status: VisaStatus) => action(CoreActionTypes.UPDATE_VISA_STATUS, status);
